import React, {Component} from 'react';

import './App.scss';

import HeadLine from './layout/HeadLine';
import Footer from './layout/Footer';
import ContentComponent from './layout/ContentComponent';
import {withFirebase} from "./firebase";
import {frameRequestService, langService} from "./services/lang.service";
import {checkURL} from "./funcs/functions";


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filterType: checkURL().category ? checkURL().category : 'all',
      list: [],
      filterList: [],
      loading: true,
      language: checkURL().language,
    };

    this.setFilterType = this.setFilterType.bind(this);
    this.loadData = this.loadData.bind(this);
    this.changeLanguage = this.changeLanguage.bind(this);
    this.getImageTo = this.getImageTo.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;

    if (this._isMounted) {
      this.loadData();
      langService.setLang(this.state.language);

      const frame = checkURL().request;

      if (frame === 'frame') {
        frameRequestService.setFrame(true);
      } else {
        frameRequestService.setFrame(false);
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    const promotions = this.props.firebase.db.ref('/promotions');
    promotions.off();
  }

  loadData() {
    // console.log('Starting Loading');
    const hash = window.location.hash.split('=?')[1];
    let filterType;

    if (hash) {
      filterType = hash;
    } else {
      filterType = this.state.filterType;
    }

    const promotions = this.props.firebase.db.ref('/promotions');

    promotions.once('value', snapshot => {
      // console.log('End Loading');

      const obj = snapshot.val();

      // console.log(obj);

      const toArrayList = Object.keys(obj).map(key => ({
        ...obj[key],
        key: key
      }));


      const messageListUpdate = toArrayList.reverse().sort((a, b) => {
        return b['changeAt'] - a['changeAt'];
      });

      const messageList = messageListUpdate.sort((a, b) => {
        return a['order'] - b['order'];
      });

      const filterList = messageList.filter(obj => {
        if (obj.type.toLowerCase() === filterType.toLowerCase()) {
          return obj;
        } else if (filterType.toLowerCase() === '' || filterType.toLowerCase() === 'all') {
          if (obj.type.toLowerCase() !== 'special') {
            return obj;
          }
        }
      });

      this.setState({
        list: toArrayList,
        filterList,
        filterType,
        loading: false
      });
    });
  }

  getImageTo(message) {
    const images = this.props.firebase.storage.ref().child('images');
    const image = images.child(message);

    return image.getDownloadURL()
      .then(
        resp => {
          return resp;
        }
      );
  }

  setFilterType(filterType) {
    // console.log('setting filter type to - ', filterType);

    const filterList = this.state.list.filter(obj => {
      if (obj.type.toLowerCase() === filterType.toLowerCase()) {
        return obj;
      } else if (filterType.toLowerCase() === '' || filterType.toLowerCase() === 'all') {
        if (obj.type.toLowerCase() !== 'special') {
          return obj;
        }
      }
    });

    this.setState({filterType, filterList});
  }

  changeLanguage(e) {
    const localLanguage = localStorage.getItem('language');

    if (!localLanguage || localLanguage !== e) {
      localStorage.setItem('language', e);
    }

    this.setState({
      language: e
    });
  }


  render() {
    const {filterType, filterList, loading} = this.state;

    return (
      <div
        className={'container-fluid main-container ' + (this.props.onModal === 'open' ? 'main-container--modal-open' : '')}>
        <HeadLine setFilterType={this.setFilterType} filterType={filterType}/>
        <ContentComponent list={filterList} loading={loading}/>
        <Footer/>
      </div>
    );
  }
}

export default withFirebase(App);
